import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ReduxInstance: "",
};

export const ReduxInstanceSlice = createSlice({
  name: "ReduxInstance",
  initialState,
  reducers: {
    chgInstance: (state, action) => {
      state.ReduxInstance = action.payload;
    },
  },
});

export const { chgInstance } = ReduxInstanceSlice.actions;

export const selectReduxInstance = (state) => state.ReduxInstance.ReduxInstance;

export default ReduxInstanceSlice.reducer;
